import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import Error from "./Error";
import LoadingScreen from "./LoadingScreen";
import { getLiveData } from "../common/helpers/LiveData";
import { unprotectedUrls } from "../common/utils/lists";
import { GET_LIVE_DATA_ERROR } from "../../store/actions/actionTypes";

const Run = ({ match, location }) => {
  const appSlug = match.params.appSlug;
  const accountSlug = match.params.accountSlug;
  const history = useHistory();

  const [freshOpen, setfreshOpen] = useState(false);
  const [errorState, setErrorState] = useState({
    code: 404,
    message: "Server error, Please reload the app again",
  });

  const dispatch = useDispatch();
  const { screensInfo, error, loading, task, workflowInstance, app } =
    useSelector(({ liveData }) => liveData);

  useEffect(() => {
    document.title = "Plug | Run App";
  }, []);

  useEffect(() => {
    const funcCall = async () => {
      const results = await dispatch(
        getLiveData({ appSlug, accountSlug, relaunch: false })
      );
      if (results?.type !== GET_LIVE_DATA_ERROR) {
        setErrorState(false);
      }
    };
    funcCall();
  }, [appSlug, accountSlug]);

  useEffect(() => {
    if (!error && !loading && screensInfo && !errorState) {
      let url = `${location.pathname}/${screensInfo.slug}?taskId=${
        task.id
      }&workflowInstanceId=${workflowInstance.id}&appId=${
        app.id
      }&new=${!freshOpen}`;

      setfreshOpen(true);

      return history.push(url);
    }
    // This check if there's screen from the backend
    if (!error && !loading && !screensInfo && !errorState) {
      history.push(unprotectedUrls.RUN_COMPLETED);
    }
  }, [screensInfo, error, loading, errorState]);

  return (
    <>
      <LoadingScreen
        loading={loading}
        message={"Initializing your application..."}
      />
      <Error
        status={error?.code || errorState?.code}
        message={error?.message || errorState?.message}
      />
    </>
  );
};

export default Run;
